import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { InputProps } from '../interfaces'

export default function useInputUnavailable(props: InputProps) {
  const { name, unavailableLabel } = props

  if (!unavailableLabel) {
    return undefined
  }

  const ctx = useFormContext()
  const watchUnavailable = ctx.watch(`${name}_unavailable`)

  useEffect(() => {
    if (!!watchUnavailable) {
      ctx.setValue(name, undefined)
    }
  }, [watchUnavailable])

  return !!watchUnavailable
}
